export const widgetPlanIds = {
  scandy: {
    city: '96f1cecf-d1ce-4b23-b73d-4d3431f7eb13',
    sandy: '8316a4ea-178b-4fee-befc-19ac5d970dcb',
    garden: 'ad027512-1857-47e2-b99a-345cf98ae27b',
    village: '4771bc4a-d1de-4ea1-afd0-7371b45070fc',
    pool: '95556aeb-a049-43eb-8199-48ef264e4ffb',
    town: '6a31479f-6433-4e33-9276-54a06298b757',
    mountains: '7de9384b-3882-4c70-8a83-ab543517c4b1',
  },
  england: {
    city: '13083794-c25a-4a67-9c62-610f277638d5',
    sandy: 'fdb27940-8554-46d7-9e98-16a7e16c0cad',
    garden: '2e13330d-e2c9-473a-9bd0-27a333e84030',
    village: '09a0409b-c0a2-4e3c-aa49-8d0bdc98ad91',
    pool: '38bb1c6d-d0b2-4361-a249-6a53fa1d2792',
    town: '10bff4f2-6ee2-4813-b44d-77eba254a3f6',
    mountains: '34774cc6-09f4-4e14-9b59-bf900a9df6ed',
  },
  boho: {
    city: 'df603f74-c23b-48e4-8bb4-217441e4edad',
    sandy: 'be59b907-8917-4e9f-8b0a-ffcc2db14c6f',
    garden: '07c37ea1-ebc8-498b-ba93-ba0a1d0dd60d',
    village: '9e80b53c-06c2-48e9-a0a2-57dbf521a018',
    pool: 'dcfe17df-8d21-4750-a9cc-105ebd01ab82',
    town: '4d84f837-9b0a-4240-adfa-42d6819cb6e7',
    mountains: 'ce217032-163c-4099-8b36-1352bb5e1222',
  },
  zero: {
    city: 'd59ae96e-bc98-4f76-a762-cf0f7080ea88',
    sandy: 'ef2d5913-6da7-4ca0-ba70-33ee691b17f5',
    garden: '5e00bf9b-a93f-4543-91a1-310238806913',
    village: 'a13d77f0-c49e-4279-b4c3-443b4e05c322',
    pool: '331f74b4-c279-4e4a-b3da-6d996516f674',
    town: '4ad1678a-ba72-4484-b738-29946de9039e',
    mountains: 'b80c432b-de77-4666-a425-2c266729b3e3',
  },
  modern: {
    city: '1d4bc3eb-6248-41e6-b9c5-715949199b28',
    sandy: '74358f5f-3aaf-456f-851f-a99469ab5a90',
    garden: '4db4e97a-7a31-4daf-8f70-fbeb9f6c37ba',
    village: '21ae6f37-77aa-4bc8-8afe-4886f3165c02',
    pool: 'b0d7b7e2-1e09-4eff-a6dc-67533c930947',
    town: 'cf1e21d3-21be-4925-a4ca-737a41af0b71',
    mountains: '395e1b3e-7693-4041-ab59-f358763a3140',
  },
  japandi: {
    city: 'b589ec4d-44e5-4180-b8b8-089715bcd3ab',
    sandy: '79880a1c-8b21-4891-8cee-b598d3c64a69',
    garden: '10a39fee-1f1f-4516-95cb-fe7a5a8f2d8e',
    village: 'bc1fa441-3b79-457a-b14a-0a9910948085',
    pool: 'a82ee6b2-35b9-401f-afec-802fe3cd7cb8',
    town: 'a52d90e5-9b75-4799-9d7f-7f444171629e',
    mountains: '28566159-00b3-42e2-bbec-4a9be39fc4e9',
  },
  elegance: {
    city: 'c8a58e01-1933-4a45-bf2f-4cfe2091643e',
    sandy: '06a50502-4756-4912-b112-15cb1013c84e',
    garden: 'dd08438e-eead-431f-afb1-defd6595e0ed',
    village: '6271df79-8b90-496b-9447-5d6551703b35',
    pool: '7d3e90ca-cc48-4e36-8cfa-c5b1652ce92d',
    town: '8ef57294-46e4-4f36-af90-4a3c055ccb3b',
    mountains: '77a5a2c1-8ef5-4b27-b2b0-6d7ae68134a2',
  },
  american: {
    city: '59c62168-b498-48e7-b152-c70141731fee',
    sandy: '67132e9a-204f-4919-91ee-ec68408c467e',
    garden: '1dfd39c0-e909-42fe-b3e0-e0f15dc146e7',
    village: '4091b63f-f6a6-47c4-945e-0b6101569a0a',
    pool: 'ebded98e-61e8-4a8e-891c-d8f0f2a62f8c',
    town: 'f9e8d1b7-1017-46d8-b5c4-1701ae40ee16',
    mountains: 'ac60695a-a103-4721-b47c-f1b407350783',
  },
};
